
import React from 'react'
import ReactDOM from 'react-dom'
 
 

 
const Modal = React.memo(({ children}) => {
  const domEl = document.getElementById('modal')
 
 
  if (!domEl) return null
  return ReactDOM.createPortal(
    <div>
      {children}
    </div>,
    domEl
  )
})
 
 
export default Modal